/* flow-strict */

function _intercom(profileCurrent, ...props) {
  let isAdmin = false;

  if (profileCurrent && profileCurrent.roles) {
    isAdmin = _.first(profileCurrent.roles).role_id === 2;
  }

  if (!isAdmin) {
    const i = window.Intercom;

    if (i) {
      i(...props);
    }
  } else {
    console.log('IntercomTrack:IsAdmin');
  }
}

export function intercomeUpdate(profileCurrent?, data?) {
  _intercom(profileCurrent, 'update', data);
}

export function intercomeBoot(profileCurrent?, data) {
  _intercom(profileCurrent, 'boot', data);
}

export function intercomeTrackEvent(profileCurrent?, name, data?) {
  _intercom(profileCurrent, 'trackEvent', name, data);
}
